import FormWithProvider from 'components/forms/form/Form';
import TextField from 'components/forms/textField/TextField';
import useCopyToClipboard from 'hooks/useCopyToClipboard';
import {
  AgencySettings,
  CustomIntegrationSettingsType,
} from 'models/InternalIntegrationSetting';
import { useTranslation } from 'react-i18next';
import { AgencyDetailsWrapper } from '../ZapierTemplates.styles';

interface AuthInformationProps {
  agencySettings: AgencySettings;
}

const AuthInformation = ({
  agencySettings: { agencyUid, customIntegrationSettings },
}: AuthInformationProps) => {
  const { t } = useTranslation();
  const { getCopyAddonIcon } = useCopyToClipboard();

  const zapierSecret =
    customIntegrationSettings?.type === CustomIntegrationSettingsType.ZAPIER &&
    !!customIntegrationSettings?.zapierSecret
      ? customIntegrationSettings?.zapierSecret
      : t('common.notApplicable');

  return (
    <>
      <h1>
        {t(
          'pageIntegrations.integrationDetails.zapier.authenticationInformation',
        )}
      </h1>
      <p>
        {t(
          'pageIntegrations.integrationDetails.zapier.authenticationDescription',
        )}
      </p>

      <FormWithProvider
        onSubmit={() => {}}
        defaultValues={{
          agencyUid,
          zapierSecret,
        }}
        noValidate
      >
        <AgencyDetailsWrapper>
          <TextField
            label={t('pageIntegrations.integrationDetails.zapier.agencyUid')}
            name="agencyUid"
            colSmLabel={2}
            colSmInput={4}
            disabled
            rightAddons={[getCopyAddonIcon(agencyUid)]}
          />

          <TextField
            label={t('pageIntegrations.integrationDetails.zapier.agencySecret')}
            name="zapierSecret"
            colSmLabel={2}
            colSmInput={4}
            disabled
            rightAddons={[getCopyAddonIcon(zapierSecret)]}
          />
        </AgencyDetailsWrapper>
      </FormWithProvider>
    </>
  );
};

export default AuthInformation;
